import { render, staticRenderFns } from "./TiniMctk.vue?vue&type=template&id=5b4ffa36&"
import script from "./TiniMctk.vue?vue&type=script&lang=js&"
export * from "./TiniMctk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports